// Reception-scoped constants + presentation helpers.
// Extracted from ReceptionTab.jsx (Iteration 62 — modularisation, 2026-08-31)
// so the giant tab can compose them via imports instead of duplicating them
// across the ScanDialog, ContactActions, OTA detail modal, etc.

// Doc types must match backend DOC_TYPES (see server.py)
export const DOC_TYPES = [
  { code: "IDELE", label: "Carta d'identità elettronica" },
  { code: "IDENT", label: "Carta d'identità cartacea" },
  { code: "PASOR", label: "Passaporto ordinario" },
  { code: "PASDI", label: "Passaporto diplomatico" },
  { code: "PASSE", label: "Passaporto di servizio" },
  { code: "PATNU", label: "Patente di guida" },
  { code: "PATE1", label: "Patente di guida (vecchio modello)" },
  { code: "STPBP", label: "Stato Patente italiana" },
  { code: "PRAG1", label: "Permesso di soggiorno (allegato al passaporto)" },
  { code: "PRAG3", label: "Permesso di soggiorno elettronico" },
];

// ISO3 → ISTAT 9-char country codes (Alloggiati Web tracciato record).
// ITALIA and common destinations are covered; extend as needed. Server-side
// fallback is "100000100" (ITALIA) when the code is unknown.
export const ISO3_TO_ISTAT = {
  // Italia
  ITA: "100000100",
  // Europe
  FRA: "100000110", DEU: "100000140", ESP: "100000120", GBR: "100000163",
  IRL: "100000102", NLD: "100000151", BEL: "100000103", CHE: "100000132",
  AUT: "100000101", PRT: "100000156", GRC: "100000144", SWE: "100000159",
  NOR: "100000153", DNK: "100000109", FIN: "100000112", POL: "100000155",
  CZE: "100000275", SVK: "100000277", HUN: "100000149", ROU: "100000105", ROM: "100000105",
  BGR: "100000108", HRV: "100000276", SVN: "100000278", ALB: "100000116",
  SRB: "100000297", MNE: "100000298", BIH: "100000273", MKD: "100000282",
  UKR: "100000268", RUS: "100000202", BLR: "100000280", MDA: "100000281",
  EST: "100000271", LVA: "100000272", LTU: "100000247", ISL: "100000104",
  MLT: "100000106", CYP: "100000107", LUX: "100000145", LIE: "100000146",
  // Americas
  USA: "400000100", CAN: "400000109", MEX: "400000117", BRA: "400000108",
  ARG: "400000103", CHL: "400000110", COL: "400000112", PER: "400000119",
  VEN: "400000123",
  // Asia
  CHN: "300000216", JPN: "300000219", KOR: "300000226", IND: "300000214",
  IDN: "300000215", PHL: "300000242", THA: "300000205", VNM: "300000225",
  ISR: "300000217", TUR: "300000241", ARE: "300000238", SAU: "300000208",
  // Africa
  EGY: "200000106", MAR: "200000112", TUN: "200000111", NGA: "200000114",
  ZAF: "200000116", KEN: "200000110",
  // Oceania
  AUS: "500000103", NZL: "500000105",
};

export const todayIso = () => new Date().toISOString().slice(0, 10);

// OTA badge helpers — mirror the coloured chips used in Dashboard's BookingsTab
// so hosts recognise the source at a glance in both views.
export function otaBadgeLabel(src) {
  const s = (src || "").toLowerCase();
  if (s.includes("booking")) return "Booking.com";
  if (s.includes("airbnb")) return "Airbnb";
  if (s.includes("expedia")) return "Expedia";
  if (s.includes("vrbo")) return "Vrbo";
  return src || "OTA";
}

export function otaBadgeColor(src) {
  const s = (src || "").toLowerCase();
  if (s.includes("booking")) return "#003580";
  if (s.includes("airbnb")) return "#FF5A5F";
  if (s.includes("expedia")) return "#F7B801";
  if (s.includes("vrbo")) return "#2E86DE";
  return "#666666";
}
